import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import TagForm, { TagFormFields } from '../../components/Tag/TagForm';

export default function TagsNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: TagFormFields) => {
    try {
      const { color, ...rest } = data;
      await api.post(`organizations/${organization.id}/tags`, {
        color: color?.replace('#', ''),
        ...rest,
      });

      navigate('/tags');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<TagFormFields>(
    {} as TagFormFields
  );

  return (
    <TagForm
      isLoading={1 + 1 === 1}
      title='Nova Etiqueta'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
